<template>
  <div class="game_Single animate__animated baise" id="gameSingle">
    <div class="game_Single_box maxWidth">
      <div class="game_Single_title">游戏专区</div>
      <div class="game_box">
        <div class="game_box_nav">
          <ul class="game_box_ul">
            <li @click="gameSingle(index)" :ref="`game_box_li${index}`" :class="item.show ? 'game_box_li_activate' : ''"
              v-for="(item, index) in gameSinglelist" :key="index">
              {{ item.title }}
            </li>
            <li class="game_box_li_special"></li>
          </ul>
          <!-- <div class="game_box_li_special"></div> -->
        </div>
      </div>
      <div class="game_Single_swiper_box">
        <div class="swiper game_Single_swiper">
          <div class="swiper-wrapper">
            <div class="swiper swiper-slide swiper-no-swiping" :class="`game_swiper_public${index}`"
              v-for="(item, index) in gameSinglelist" :key="index">
              <div class="swiper-wrapper">
                <div class="swiper-slide swiper-no-swiping" v-for="(li, liindex) in item.list">
                  <ul :key="liindex" class="game_Single_swiper_ul" v-if="index < gameSinglelist.length - 1">
                    <!-- :class="liitem.show ? 'game_Single_swiper_li_activate':''" -->
                    <!-- @mouseover.stop.prevent="gameSingleMous(index,liindex,liitemindex)"
												@mouseout.stop.prevent ="gameSingleeout(index,liindex,liitemindex)" -->
                    <li class="game_Single_swiper_li" @click="tolink(liitem)"
                      v-for="(liitem, liitemindex) in li" :key="liitemindex">
                      <div class="game_Single_swiper_li_size_activate">
                        {{ liitem.name }}
                      </div>
                      <div :style="{
                        background:
                          'url(' + liitem.img + ') no-repeat center',
                      }"></div>
                      <div>
                        <div class="game_Single_swiper_li_size_activate" v-for="(des, desindex) in liitem.describe"
                          :key="desindex">
                          <div v-if="desindex < 3">{{ des }}</div>
                          <div class="game_Single_swiper_li_size_activate" v-else>
                            {{ des }}
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                  <div class="game_Single_newest" v-else>
                    <div class="game_Single_newest_left" @click="tolink(li[0])">
                      <div class="game_Single_newest_left_img" :style="{
                        backgroundImage: 'url(' + li[0].img + ')',
                      }"></div>

                      <div class="game_Single_newest_left_box1">
                        <div>{{ li[0].name }}</div>
                        <div>{{ li[0].show_time }}</div>
                      </div>
                      <div class="game_Single_newest_left_box2">
                        {{ li[0].desc }}
                      </div>
                    </div>
                    <div class="game_Single_newest_right">
                      <div @click="tolink(des)" class="game_Single_newest_right1"
                        v-for="(des, desindex) in li" :key="desindex">
                        <div class="game_Single_newest_right1_img" :style="{
                          background: 'url(' + des.img + ') no-repeat center',
                        }"></div>
                        <div class="game_Single_newest_right1_info">
                          <div>
                            <div class="game_Single_swiper_li_size_activate">
                              {{ des.name }}
                            </div>
                            <div class="game_Single_swiper_li_size_activate">
                              {{ des.show_time }}
                            </div>
                          </div>
                          <div class="game_Single_newest_right1_info2 game_Single_swiper_li_size_activate">
                            {{ des.desc }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="newestInfoShow" class="game_Single_swiper_left" @click="cutGameSingle('left')">
          <img v-if="gameleftShow" src="../../assets//images/game_Single_left2.png" alt="" />
          <img v-else src="../../assets/images/game_Single_left1.png" alt="" />
        </div>
        <div v-if="newestInfoShow" class="game_Single_swiper_right" @click="cutGameSingle('right')">
          <img v-if="gamerightShow" src="../../assets/images/game_Single_right2.png" alt="" />
          <img v-else src="../../assets/images/game_Single_right1.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { convertTo2DArray } from "@/utils/index";
import { mapState } from 'vuex';
import { downloadA } from "@/utils/download";
import { customText } from '@/utils/key'
export default {
  data() {
    return {
      gameleftShow: true,
      newestInfoShow: true,
      gamerightShow: false,
      gameSwiper: null,
      gameSwiperList: [],
      gameSinglelist: [
        {
          title: "近期测试",
          show: false,
          list: [],
        },
        {
          title: "正版授权游戏",
          show: true,
          list: [],
        },
        {
          title: "违规游戏公示",
          show: false,
          list: [],
        },
        {
          title: "最新资讯",
          show: false,
          list: [],
        },
      ],
    };
  },
  created() {
  },
  mounted() {
    this.$nextTick(() => {
      this.gameSingleroll();
    });
    window.addEventListener("resize", this.handleResize);
  },
  computed: {
    ...mapState({
      speciallyGameList: (state) => state.init.speciallyGameList,
    })
  },
  watch: {
    speciallyGameList: {
      handler(val) {
        let arr = []
        for (const key in val) {
          let list = val[key];
          list.forEach(item => {
            item.show = false
            if (key != 'list4') {
              item.describe = [
                `版本：${item.cate_name}`,
                `上线时间：${item.online_time}`,
                `最新开服时间:${item.open_time}`,
                `官网：${item.url}`
              ]
            }
          })
        }
        this.gameSinglelist[0].list = convertTo2DArray(val.list1)
        this.gameSinglelist[1].list = convertTo2DArray(val.list2)
        this.gameSinglelist[2].list = convertTo2DArray(val.list3)
        this.gameSinglelist[3].list = convertTo2DArray(val.list4, 3)
        console.log(arr, 'arr')
        this.$nextTick(() => {
          this.gameSingleSwiper();
        })
      },
      deep: true,
      immediate: true
    },
  },
  methods: {

    handleResize() {
      let time = setTimeout(() => {
        this.gameSingleroll();
        clearTimeout(time);
      }, 500);
    },
    gameSingleroll() {
      try {
        let index = this.gameSinglelist.findIndex((item) => item.show);
        let special = document.querySelector(".game_box_li_special");
        let specialclientWidth =
          (document.querySelector(".game_box_li_special").clientWidth -
            this.$refs[`game_box_li${index}`][0].clientWidth) /
          2;
        let left =
          this.$refs[`game_box_li${index}`][0].offsetLeft - specialclientWidth;
        special.style.transform = `translateX(${left}px)`;
      } catch (error) { }
    },
    gameSingleSwiper() {
      // 默认显示第几个的swiper
      let index = this.gameSinglelist.findIndex((item) => item.show);
      // 游戏专区
      this.gameSwiper = new Swiper(".game_Single_swiper", {
        centeredSlides: true,
        initialSlide: index,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper，主要是这两行
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
      });
      this.gameSwiperList = [];

      this.gameSinglelist.forEach((item, index) => {
        let swiper = new Swiper(`.game_swiper_public${index}`, {
          centeredSlides: true,
          loop: true,
          observer: true, //修改swiper自己或子元素时，自动初始化swiper，主要是这两行
          observeParents: true, //修改swiper的父元素时，自动初始化swiper
        });

        this.gameSwiperList.push(swiper);
      });
    },
    cutGameSingle(direction) {
      let index = this.gameSinglelist.findIndex((item) => item.show);
      if (direction == "left") {
        this.gameleftShow = true;
        this.gamerightShow = false;
        this.gameSwiperList[index].slidePrev();
        // this.gameSwiper.slidePrev();
      } else {
        this.gameleftShow = false;
        this.gamerightShow = true;
        this.gameSwiperList[index].slideNext();
      }

      // this.gameSinglelist.forEach(item => {
      // 	item.show = false
      // })
      // let index = this.gameSwiper.realIndex
      // this.gameSinglelist[index].show = true
      if (index > 2) {
        // this.newestInfoShow = false
      } else {
        this.newestInfoShow = true;
      }
      // this.gameSingleroll()
    },
    tolink(item) {
      switch (item.type) {
        case 1:
          downloadA(item.url)
          break;
        case 2:
          if (item.content) {
            localStorage.setItem(customText, item.content);
            let href = window.location.href
            window.open(`${href}custom`)
          }
          break;
        case 3:
          if (item.url) {
            this.$router.push({
              path: item.url,
            })
          }
          break;
        default:
          break;
      }
    },
    // 游戏专区nav 切换
    gameSingle(index) {
      if (this.gameSinglelist[index].list.length == 0) {
        this.newestInfoShow = false;
      } else {
        this.newestInfoShow = true;
      }
      if (index < this.gameSwiper.realIndex) {
        this.gameleftShow = true;
        this.gamerightShow = false;
      } else {
        this.gameleftShow = false;
        this.gamerightShow = true;
      }

      this.gameSinglelist.forEach((item) => {
        item.show = false;
      });
      this.gameSinglelist[index].show = true;

      this.gameSwiper.slideToLoop(index, 1000, false);
      this.gameSingleroll();
    },
  },
};
</script>

<style scoped lang="scss">
/* 游戏专区 */
.baise {
  background: #ffffff;
}

.game_Single {
  padding-bottom: 0.5125rem
    /* 41/80 */
  ;
}

.game_Single_box {
  height: 100%;
}

.game_Single_title {
  color: #000;
  font-size: 0.45rem
    /* 36/80 */
  ;
  font-weight: bold;
  text-align: center;
  padding-top: 0.625rem
    /* 50/80 */
  ;
  padding-bottom: 0.575rem
    /* 46/80 */
  ;
  height: 46px;
}

.game_box {
  width: 15.275rem
    /* 1222/80 */
  ;
  margin: 0 auto;
}

.game_box_nav {
  border-bottom: 1px solid #cdcdcc;
  display: flex;
  justify-content: center;
  position: relative;
}

.game_box_ul {
  margin: 0 auto;
  display: flex;
  position: relative;
}

.game_box_ul>li {
  font-size: 0.25rem
    /* 20/80 */
  ;
  color: #34332f;
  margin-right: 1.5125rem
    /* 121/80 */
  ;
  padding-bottom: 0.3375rem
    /* 27/80 */
  ;
  cursor: pointer;
  font-family: MicrosoftYaHei-, MicrosoftYaHei;
}

.game_box_ul .game_box_li_special {
  margin: 0;
  padding: 0;
  width: 1.5125rem
    /* 121/80 */
  ;
  height: 0.025rem
    /* 2/80 */
  ;
  position: absolute;
  bottom: 0;
  left: 0;
  transition: transform 500ms cubic-bezier(0.48, 0.33, 0.24, 0.95) 0ms;

  background: red;
}

.game_box_ul>li:last-child {
  margin-right: 0;
}

.game_Single_swiper {
  height: 7.5rem
    /* 600/80 */
  ;
}

.game_public {
  height: 7.5rem
    /* 600/80 */
  ;
}

.game_Single_swiper_ul {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  margin: 0 auto;
  width: 15.275rem !important;
}

.game_Single_swiper_ul>li {
  margin-right: 0.425rem;
  width: calc(3.4rem - 0.275rem);
  background: #ffffff;
  box-shadow: 1px 0.0375rem 0.0875rem 1px rgba(0, 0, 0, 0.21);
  border-radius: 0.125rem;
  padding-left: 0.2875rem;
  padding-right: 0.275rem;
  cursor: pointer;
  padding-bottom: 0.3375rem;
  height: 4.2375rem !important;
}

.game_Single_swiper_li_activate {
  background: #982721 !important;
}

/* 游戏专区 */
.game_Single_swiper_li:hover {
  background: #982721 !important;
}

.game_Single_swiper_li:hover .game_Single_swiper_li_size_activate {
  color: #fff !important;
}

/* 最新资讯 */
.game_Single_newest_right1:hover {
  background: #982721 !important;
}

.game_Single_newest_right1:hover .game_Single_swiper_li_size_activate {
  color: #fff !important;
}

.game_Single_swiper_ul>li:last-child {
  margin-right: 0;
}

.game_Single_swiper_li>div:nth-child(1) {
  font-size: 0.225rem;
  padding-top: 0.2625rem;
  padding-bottom: 0.3875rem;
  color: #000;
  font-weight: bold;
}

.game_Single_swiper_li>div:nth-child(2) {
  width: 2.8375rem;
  height: 1.4375rem;
  background: #ffffff;
  border-radius: 0.125rem
    /* 10/80 */
  ;
  margin-bottom: 0.3625rem
    /* 29/80 */
  ;
  background-size: cover !important;
}

.game_Single_swiper_li>div:nth-child(3)>div {
  color: #666666;
  line-height: 0.375rem
    /* 30/80 */
  ;
  font-size: 0.175rem
    /* 14/80 */
  ;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.game_Single_swiper_li>div:nth-child(3)>div a {
  color: #666666;
}

.game_box_ul .game_box_li_activate {
  color: #992923;
  transition: transform 500ms cubic-bezier(0.48, 0.33, 0.24, 0.95) 0ms;
}

.game_Single_swiper_box {
  margin: 0 auto;
  position: relative;
  width: 15.525rem
    /* 1242/80 */
  ;
  width: 16.25rem
    /* 1300/80 */
  ;
}

.game_Single_swiper_left {
  position: absolute;
  left: -0.875rem
    /* 70/80 */
  ;
  top: 50%;
  transform: translateY(-50%);
  width: 0.5875rem
    /* 47/80 */
  ;
  height: 0.5875rem
    /* 47/80 */
  ;
  z-index: 1;
  cursor: pointer;
}

.game_Single_swiper_left>img {
  display: block;
  width: 100%;
  height: 100%;
}

.game_Single_swiper_right {
  position: absolute;
  right: -0.875rem
    /* 70/80 */
  ;
  top: 50%;
  transform: translateY(-50%);
  width: 0.5875rem
    /* 47/80 */
  ;
  height: 0.5875rem
    /* 47/80 */
  ;
  z-index: 1;
  cursor: pointer;
}

.game_Single_swiper_right>img {
  display: block;
  width: 100%;
  height: 100%;
}

.game_Single_newest {
  display: flex;
  padding-top: 0.8rem
    /* 64/80 */
  ;
  margin: 0 auto;
  width: 15.275rem
    /* 1222/80 */
  ;
  justify-content: space-between;
}

.game_Single_newest_left {
  width: 7.125rem
    /* 570/80 */
  ;
  height: 5.6625rem
    /* 453/80 */
  ;
  background: #ffffff;
  box-shadow: 0px 0px 0.225rem
    /* 18/80 */
    1px rgba(0, 0, 0, 0.27);
  border-radius: 0.125rem
    /* 10/80 */
  ;
  opacity: 1;
  cursor: pointer;
}

.game_Single_newest_left_img {
  overflow: hidden;
  border-radius: 0.125rem
    /* 10/80 */
  ;
  width: 100%;
  height: 3.8625rem
    /* 309/80 */
  ;
  background: url("../../assets/images/pc/game/journalism/bxqn.png") no-repeat center;
  background-size: cover !important;
  background-position: center;
}

.game_Single_newest_left_img1 {
  overflow: hidden;
  border-radius: 0.125rem
    /* 10/80 */
  ;
  width: 100%;
  height: 3.8625rem
    /* 309/80 */
  ;
  background: url("../../assets/images/pc/game/journalism/570309.jpg") no-repeat center;
  background-size: cover !important;
}

.game_Single_newest_left_box1 {
  padding-top: 0.2375rem
    /* 19/80 */
  ;
  display: flex;
  justify-content: space-between;
  padding-left: 0.25rem
    /* 20/80 */
  ;
  padding-right: 0.2125rem
    /* 17/80 */
  ;
  line-height: 0.375rem
    /* 30/80 */
  ;
  box-sizing: border-box;
}

.game_Single_newest_left_box1>div:nth-child(1) {
  color: #000000;
  // font-size: 0.2rem;
  font-size: .175rem
    /* 14/80 */
  ;
  font-size: .1625rem
    /* 13/80 */
  ;
  font-weight: bold;
}

.game_Single_newest_left_box1>div:nth-child(2) {
  color: #666666;
  font-size: 0.2rem
    /* 16/80 */
  ;
  font-size: .15rem
    /* 12/80 */
  ;

}

.game_Single_newest_left_box2 {
  line-height: 0.375rem
    /* 30/80 */
  ;
  font-size: 0.175rem;
  color: #666666;
  box-sizing: border-box;
  padding: 0 0.275rem;
  position: relative;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.game_Single_newest_left_box2>div:nth-child(2) {
  color: #982721;
  position: absolute;
  right: 0.275rem;
  bottom: 0;
}

.game_Single_newest_right {
  display: flex;
  flex-direction: column;
}


.game_Single_newest_right1 {
  cursor: pointer;
  box-sizing: border-box;
  padding: 0.225rem
    /* 18/80 */
    0;
  padding-left: 0.175rem
    /* 14/80 */
  ;
  padding-right: 0.3rem
    /* 24/80 */
  ;
  display: flex;
  width: 7.35rem
    /* 588/80 */
  ;
  height: 1.7625rem
    /* 141/80 */
  ;
  background: #ffffff;
  box-shadow: 0px 0px 0.225rem
    /* 18/80 */
    1px rgba(0, 0, 0, 0.27);
  border-radius: 0.125rem
    /* 10/80 */
  ;
  justify-content: space-between;
}

.game_Single_newest_right1+.game_Single_newest_right1 {
  margin-top: .1875rem
    /* 15/80 */
  ;
}

.game_Single_newest_right1_img {
  width: 1.7875rem
    /* 143/80 */
  ;
  height: 1.3rem
    /* 104/80 */
  ;
  background: #912920;
  border-radius: 0.125rem
    /* 10/80 */
  ;
  background-size: 100% 100% !important;
}

.game_Single_newest_right1_info {
  width: 4.825rem
    /* 386/80 */
  ;
  height: 0.6125rem
    /* 49/80 */
  ;
}

.game_Single_newest_right1_info>div:nth-child(1) {
  display: flex;
  justify-content: space-between;
  color: #000000;
  font-size: 0.2rem
    /* 16/80 */
  ;
  padding-top: 0.1375rem
    /* 11/80 */
  ;
  padding-bottom: 0.125rem
    /* 10/80 */
  ;
}

.game_Single_newest_right1_info>div:nth-child(1)>div:nth-child(1) {
  font-weight: bold;
  width: 3.4875rem
    /* 279/80 */
  ;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.game_Single_newest_right1_info>div:nth-child(1)>div:nth-child(2) {
  color: #666666;
  font-size: 0.175rem
    /* 14/80 */
  ;
  width: 1.025rem
    /* 82/80 */
  ;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.game_Single_newest_right1_info2 {
  font-size: 0.175rem
    /* 14/80 */
  ;
  line-height: 0.375rem
    /* 30/80 */
  ;

  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

/* 游戏专区 */
</style>
